import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import {SlideDown} from 'react-slidedown'
import Loader from 'react-loader'
import {
  Link
} from '../'
import * as searchActions from 'redux/modules/search'
import Styles from './ScreenedCompanies.css'


@CSSModules(Styles, {allowMultiple: true})
class ScreenedCompaniesTable extends Component {
  static propTypes = {
    companies: PropTypes.array.isRequired,
  }
  constructor(props){
    super(props)
    this.state = {}
  }
  render() {
    return (
      <table styleName='t-table'>
        <thead>
          <tr>
            <th>Company</th>
            <th>Symbol</th>
          </tr>
        </thead>
        <tbody>
          { 
            this.props.companies.map((c, i)=>{
              return (
                <tr key={c.primary_symbol + '-' + i}>
                  <td>{c.short_name}</td>
                  <td>{c.primary_symbol}</td>
                </tr>
              )
            }) 
          }
        </tbody>
      </table>
    )
  }
}


@connect(
  state => ({
    result: state.company.result,
    searching: state.company.loading,
    searched: state.company.loaded,
    error: state.company.error
  }),
  searchActions)
@CSSModules(Styles, {allowMultiple: true})
export default class ScreenedCompanies extends Component {
  static propTypes = {
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.array,
    // search: PropTypes.func,
  }
  constructor(props){
    super(props)
    this.state = {
    }
  }
  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
    this.props.companies()
  }

  componentWillReceiveProps(props){
    if (props.result) {
      let gmCompanies = []
      let grCompanies = []
      props.result.map((el)=>{
        if (el.is_gm) gmCompanies.push(el)
        if (el.is_gr) grCompanies.push(el)
        return false
      })
      const _sorter = (a, b)=>{
        const lbl = 'short_name'
        const a_s = a[lbl].toLowerCase()
        const b_s = b[lbl].toLowerCase()
        return a_s.localeCompare(b_s)
      }
      gmCompanies = gmCompanies.sort(_sorter)
      grCompanies = grCompanies.sort(_sorter)
      this.setState({
        gmCompanies,
        grCompanies
      })
    }
  }

  render() {
    if (!this.props.result || !this.state.gmCompanies || !this.state.grCompanies) {
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'4.0rem'}}
            loaded={ false }
          />
        </div>
      )
    }

    const icons = {
      gm: require( '../../../static/images/icn-gm.svg' ),
      gr: require( '../../../static/images/icn-gr.svg' )
    }

    return (
      <div styleName='main-wrap'>

        <div styleName='screen-card'>
          <div styleName='screen-bullet'>
            <img
              styleName='screen-icon'
              alt='Gun manufacturers'
              src={icons.gm}
            />
            <div styleName='screen-icon-label'>
              <p>
                <span styleName='bold'>Gun manufacturers</span> &mdash; On an
                average day, 93 Americans are killed with guns. Over 90% of
                the country supports expanding background checks to all gun
                sales and the majority supports increased safety regulation,
                but many of these same people are invested their savings in
                firearm manufacturers and don’t even know it. This list
                represents the leading public companies involved in
                manufacturing civilian firearms including handguns, rifles,
                and ammunition.
              </p>
              <p>
                The primary source data for these lists are exclusion screens
                from asset managers:
                <ul>
                  <li>
                    <Link
                      to='https://iyv-charts.s3.us-west-2.amazonaws.com/exclusion-lists/anz-excluded-companies-jul-2025.pdf'
                      title='ANZ Excluded Companies July 2025 - Civilian firearms'
                      xstrong
                    >
                      ANZ Excluded Companies July 2025 - Civilian firearms
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='https://iyv-charts.s3.us-west-2.amazonaws.com/exclusion-lists/nz-superfund-exclusions-list-aug-2025.xlsx'
                      title='NZ Super Fund Exclusions August 2025'
                      xstrong
                    >
                      NZ Super Fund Exclusions August 2025 - Civilian automatic and semi-automatic firearms
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='https://iyv-charts.s3.us-west-2.amazonaws.com/exclusion-lists/robeco-exclusions-list-aug-2025.pdf'
                      title='Robeco Institutional Asset Management Exclusions List August 2025'
                      xstrong
                    >
                      Robeco Institutional Asset Management Exclusions List August 2025 - Firearms
                    </Link>
                  </li>
                </ul>
              </p>
            </div>
          </div>
          <ScreenedCompaniesTable companies={this.state.gmCompanies}/>
        </div>

        <div styleName='screen-card'>
          <div styleName='screen-bullet'>
            <img
              styleName='screen-icon'
              alt='Major gun retailers'
              src={icons.gr}
            />
            <div styleName='screen-icon-label'>
              <p>
                <span styleName='bold'>Major gun retailers</span> &mdash;
                Retailers selling handguns, shotguns, rifles, and ammunition
                &mdash; including high-capacity magazines and semiautomatic
                weapons known commonly as “assault rifles” &mdash; are raking
                in billions in weapons sales. We don’t need to finance
                violence in order to invest in our own retirement accounts.
                The gun retailers listed here represent the largest public
                companies that sell firearms or ammunition to the civilian
                market.
              </p>
            </div>
          </div>
          <ScreenedCompaniesTable companies={this.state.grCompanies}/>
        </div>
      </div>
    )
  }
}

